module.exports = __webpack_public_path__ + "img/dy_code.a43a5d1b.png";